import script from "./AuditDeclare.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuditDeclare.vue?vue&type=script&lang=ts&setup=true"

import "./AuditDeclare.vue?vue&type=style&index=0&id=5d890c13&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d890c13"]])

export default __exports__